import React from 'react';
import { connect } from 'react-redux';
import Table from 'components/shared/table';
import AttendanceRow from './AttendanceRow';

const AttendeesTable = ({ attendances }) => (
  <Table alternate className="mt-16 bdrs-small ov-h">
    <Table.Header>
      <Table.HeaderCell>{t('common.name')}</Table.HeaderCell>
    </Table.Header>
    <div className="Table-body">
      {attendances.map(attendance => (
        <AttendanceRow key={attendance.id} attendance={attendance} />
      ))}
    </div>
  </Table>
);

const mapStateToProps = state => ({
  attendances: state.attendances,
});

export default connect(mapStateToProps)(AttendeesTable);
